
import { computed, defineComponent, PropType } from 'vue';
import Item from './item.vue';
import AppLink from './link.vue';
import { IMenuItem } from '@/store/menu/type.d';
import { createRouterMatcher } from 'vue-router';
import router from '@/router';
import { RESOURCE_TYPE_ENUM } from '@/api/menu/type';

const matcher = createRouterMatcher(router.getRoutes(), {});

interface IProps {
  item: IMenuItem;
  basePath?: string;
  collapse?: boolean;
}

export default defineComponent({
  name: 'SidebarItem',
  components: {
    Item,
    AppLink,
  },
  props: {
    item: {
      type: Object as PropType<IMenuItem>,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    collapse: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: IProps) {
    const currentItem = computed(() => {
      const { item } = props;
      if (item?.frontEndUrl && !(typeof item?.hidden === 'boolean')) {
        const routeRes = matcher.getRecordMatcher(item.frontEndUrl);

        return Object.assign(item, {
          hidden: routeRes?.record?.meta?.hidden,
        });
      }
      return item;
    });
    const children = computed(() => {
      return (props.item.children || []).filter((it) => {
        /**
         * 必须不是按钮资源
         * 按钮资源没必要判断
         */
        const isNotBtnLib = it.resourceType !== RESOURCE_TYPE_ENUM.BUTTON;

        if (isNotBtnLib && it.frontEndUrl) {
          const routeRes = matcher.getRecordMatcher(it.frontEndUrl);

          if (routeRes?.record?.meta?.hidden === true) {
            return false;
          }
          return true;
        }

        return isNotBtnLib;
      });
    });

    return {
      currentItem,
      children,
    };
  },
});
